const prefix = 'VALUE_CHAIN_MAP/';

export const VALUE_CHAIN_MAP_LIST_TAG = `${prefix}VALUE_CHAIN_MAP_LIST`;
export const VALUE_CHAIN_MAP_ANALYSES_TAG = `${prefix}VALUE_CHAIN_MAP_ANALYSES`;
export const VALUE_CHAIN_MAP_DETAILS_TAG = `${prefix}VALUE_CHAIN_MAP_DETAILS`;
export const VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG = `${prefix}VALUE_CHAIN_MAP_BUSINESS_STRUCTURE`;
export const VALUE_CHAIN_MAP_BOARD_TAG = `${prefix}VALUE_CHAIN_MAP_BOARD`;
export const VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG = `${prefix}VALUE_CHAIN_MAP_ORG_STRUCTURE`;
export const VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG = `${prefix}VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES`;
